import CustomSubscriptionClient from '@/client/hooks/useSubscription/getSubscriptionClient/CustomSubscriptionClient';
import mapHttpsUriToWss from '@/shared/utils/mapHttpsUriToWss';

const getSubscriptionClient = (context: WorkerContext) => {
  const { endpoint, token } = context;
  return new CustomSubscriptionClient(mapHttpsUriToWss(endpoint), {
    token,
    reconnect: true,
    lazy: true,
  });
};
export default getSubscriptionClient;
